import { SERVER_USERS_ENDPOINT } from '../../configs/endpoints'
import { axioService, GET, PATCH } from '../../services/axios'
import {
  GetUserListPayload,
  GetUserlistResponse,
  ServerUserResponse,
} from './models'
import { MapUserFromServer } from './mappings'
import { UpdateUserObj } from '../../store/slices/userlist/slice'

export const getUserlistFromServer = async (
  payload: GetUserListPayload
): Promise<GetUserlistResponse> => {
  const {
    offset,
    limit,
    search,
    enabled,
    inclGroupId,
    exclGroupId,
    exclRoleId,
  } = payload
  const response = await axioService(
    GET,
    SERVER_USERS_ENDPOINT,
    {
      offset,
      limit,
      q: search.trim() ? search : null,
      enabled,
      inclGroupId,
      exclGroupId,
      exclRoleId,
    },
    true
  )
  const { data, total_count, ...rest } = response.data
  return {
    ...rest,
    totalCount: total_count,
    data: data.map((iter: ServerUserResponse) => MapUserFromServer(iter)),
  }
}

export const updateUserActivationInServer = async (
  userPayload: UpdateUserObj
) => {
  const response = await axioService(
    PATCH,
    SERVER_USERS_ENDPOINT + '/' + userPayload.userId,
    {
      ...(userPayload.enabled !== undefined && {
        enabled: userPayload.enabled,
      }),
      ...(userPayload.globalRole !== undefined && {
        global_role: userPayload.globalRole || false,
      }),
      ...(userPayload.portalAdmin !== undefined && {
        portal_admin: userPayload.portalAdmin,
      }),
    },
    true
  )
  return response.status
}
